import { combineReducers } from 'redux';
import { reducer as responsiveReducer } from 'react-responsive-redux';
import configReducer from './config';
import fetcherReducer from './fetcher';
import menuReducer from './menu';
import statusReducer from './status';

const rootReducer = combineReducers({
	responsive: responsiveReducer,
	config: configReducer,
	fetcher: fetcherReducer,
	menu: menuReducer,
	status: statusReducer,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.jsx